<!--多选和不定项选择-->
<template>
<div class="Checkbox">
    <el-form-item label="题目" required>
        <uEditor :content="formData.subject" ref="subject" @getUEditorContent="getUEditorSubjectContent"></uEditor>
    </el-form-item>
    <el-form-item :label="'选项'+endlish[index]" required v-for="(item, index) in formData.optioninfo" :key="index">
        <uEditor :index='index' :content="item.optionsinfo" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
         <el-checkbox v-model="item.isrightanswer" :label="index">设为正确答案</el-checkbox>
        <div class="del" v-if="formData.optioninfo.length > 1" @click="delOption(index)">
            <img src="@/common/images/other/icon-del.png" alt="del">
        </div>
    </el-form-item>
    <el-form-item>
        <el-button v-if="formData.optioninfo.length < endlish.length" type="primary" plain @click="addOption">+ 新增选项
        </el-button>
    </el-form-item>
    <el-form-item label="试题解析">
        <uEditor :content="formData.quesanalysis" ref="quesanalysis"
                 @getUEditorContent="getUEditorQuesanalysisContent"></uEditor>
    </el-form-item>
    <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
    </el-form-item>
</div>
</template>

<script>
import $ from 'jquery'
import UEditor from 'base/uEditor/uEditor4'
import {letter} from 'api/enumCode'
export default {
    name: 'Checkbox',
    props: ['formData', 'type'],
    data() {
        return {
            endlish: 'ABCDEFGHIJ', // 英文列表
            optioninfo: {   // 试题选项信息，选择题有效，解析之后为一个数组，前端选先后顺序组装 optionsinfo 选项名称 isrightanswer 是否正确答案 0否 1是
                optionid: '',
                optionsinfo: '',   // 选项名称
                isrightanswer: 0,  // 是否正确答案，接口返回 0或者1
                isrightanswerpage: false,  // 是否正确答案，格式化成false true，分开保存，避免提交报错的时候需要转换
            }
        }
    },
    mounted() {
        if (this.type == 1) {
            // 非编辑情况下
            this._initCheckbox()
        } else {
            this.editMsg(this.formData)
        }
    },
    methods: {
        cancel() {  // 返回题库
            this.$emit('cancel')
        },
        _initCheckbox() {    // 初始化数据
            this.$nextTick(() => {
                this.addOption()
                this.addOption()
            })
        },
        addOption() { // 增加新选项
            let obj = this._.cloneDeep(this.optioninfo)
            this.formData.optioninfo.push(obj)
        },
        delOption(index) { // 删除选项 index 下标
            this.formData.optioninfo.splice(index, 1)
            // 删除无用Textarea 标签
            this.$nextTick(() => {
                $("textarea[name='editorValue']").each(function () {
                    let style = $(this).attr('style')
                    if (style == 'width: 0px; height: 0px;') {
                        $(this).remove()
                    }
                })
            })
        },
        submit() {    // api 数据提交
            let int = 0
            let item = this._.cloneDeep(this.formData)
            item.optioninfo.forEach((obj, index) => {
                if (!obj.optionsinfo) {
                    this.$message.error('选项' + letter[index] + '题目不能为空')
                } else {
                    if (obj.isrightanswer) {
                        obj.isrightanswer = 1
                        int ++
                    } else {
                        obj.isrightanswer = 0
                    }
                }
            })
            if (!int) {
                this.$message.error('答案不能为空')
                return
            }
            this.$emit('childSubmitFormApi', JSON.stringify(item))
        },
        editMsg(formData) {   // 编辑内容，后台接口直接返回bool类型对象  isrightanswerpage
            formData.optioninfo.forEach(obj => {
                if(obj.isrightanswer === 1 || obj.isrightanswer === '1'){
                    obj.isrightanswer = true
                }
                else{
                    obj.isrightanswer = false
                }
            })
        },
        getUEditorSubjectContent(content) {
            this.formData.subject = content
        },
        getUEditorQuesanalysisContent(content) {
            this.formData.quesanalysis = content
        },
        getUEditorContent(content, index) {
            this.formData.optioninfo[index].optionsinfo = content
        },
    },
    filters: {},
    watch: {
        formData: {
            handler(newV, oldV) {
                if (newV.questiontype != oldV.questiontype) {
                    this._initCheckbox()
                }
            }
        },
        deep: true
    },
    computed: {},
    components: {
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.Checkbox {
    .uEditor {
        .ue_btn {
            display: none;
        }
    }
    .del {
        position: absolute;
        top: 0;
        right: -40px;
        cursor: pointer;
        img {
            width: 12px;
            height: 12px;
        }
    }
}
</style>
